<template>
    <div class="booking-summary d-none d-xl-flex">
        <div class="container ">
            <div class="row mb-4 justify-content-center">
                <div class=" col-xl-6  mb-3 "
                     v-bind:class="{'offset-xl-2' : (roomSummaries.length == 1)}">
                    <div class="has-shadow panel panel--primary h-100 d-flex justify-content-center align-items-center flex-column p-3">
                        <span class="summary-title">
                            Your booking
                        </span>
                        {{dates}}
                    </div>
                </div>
           
                <div v-bind:class="{'col-xl-14' : roomSummaries.length == 1 , 'col-xl-18' : roomSummaries.length > 1}">
                    <div class="row">

                        <div class="mb-3"
                             v-bind:class="{'col-xl-20' : roomSummaries.length == 1 , 'col-xl-12' : roomSummaries.length > 1}"
                             v-bind:key="legSummary.leg"
                             v-for="legSummary in roomSummaries">
                            <div class="has-shadow panel  p-4   h-100 " v-bind:class="getCssClass(legSummary.leg)">
                                <div class="row">
                                    <div class="col-xl-4">
                                        <span class="room">
                                            Room {{legSummary.leg}}:
                                        </span>
                                    </div>
                                    <div class="col-xl-20">
                                        <div class="row">
                                            <div class="col-5"><span class="summary-label">Guests:</span></div>
                                            <div class="col-14"> {{legSummary.guestCountSummary}}</div>
                                            <div class="col-5"> </div>
                                        </div>

                                        <div class="row" v-if="legSummary.dogs">
                                            <div class="col-5"><span class="summary-label">Dogs:</span></div>
                                            <div class="col-14"> {{legSummary.dogs}}</div>
                                            <div class="col-5">
                                                <span class="room" v-if="getDogsAmount(legSummary) > 0">
                                                    &pound;{{priceFormatted(getDogsAmount(legSummary))}}
                                                </span>
                                            </div>
                                        </div>





                                        <div class="row">
                                            <div class="col-5"><span class="summary-label">Room:</span></div>
                                            <div class="col-14">{{legSummary.room || '-'}}</div>
                                            <div class="col-5"> </div>
                                        </div>




                                        <div class="row" v-if="legSummary.amount">
                                            <div class="col-5"><span class="summary-label">Rate:</span></div>
                                            <div class="col-14">{{legSummary.rate || '-'}}</div>
                                            <div class="col-5">
                                                <span class="room">
                                                    &pound;{{legSummary.amount}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="row" v-if="legSummary.children">
                                            <div class="col-5"><span class="summary-label">Child Rate:</span></div>
                                            <div class="col-14"> x {{legSummary.children}}</div>
                                            <div class="col-5">
                                                <span class="room" v-if="getChildrenAmount(legSummary) != null">
                                                    &pound;{{priceFormatted(getChildrenAmount(legSummary))}}
                                                </span>
                                            </div>
                                        </div>

                                        <div class="row" v-if="legSummary.infants">
                                            <div class="col-5"><span class="summary-label">Infant Rate:</span></div>
                                            <div class="col-14"> x {{legSummary.infants}}</div>
                                            <div class="col-5">
                                                <span class="room" v-if="getInfantsAmount(legSummary) != null">
                                                    &pound;{{priceFormatted(getInfantsAmount(legSummary))}}
                                                </span>
                                            </div>
                                        </div>


                                        <div class="row" v-if="legSummary.addons.length">
                                            <div class="col-5"><span class="summary-label">Add Ons:</span></div>
                                            <div class="col-14">
                                                <div v-for="(addon) in legSummary.addons">

                                                    {{addon || '-'}}
                                                </div>
                                            </div>
                                            <div class="col-5">
                                                <span class="room" v-if="legSummary.addonsAmount > 0">
                                                    &pound;{{legSummary.addonsAmount}}
                                                </span>

                                            </div>
                                        </div>

                                        <div class="row" v-if="legSummary.totalAmount && legSummary.totalAmount != legSummary.amount">
                                            <div class="col-19"><span class="summary-label">Total:</span></div>

                                            <div class="col-5">
                                                <span class="room">
                                                    &pound;{{legSummary.totalAmount}}
                                                </span>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>


    <div class="booking-summary booking-summary-m  d-xl-none ">
        <div class="container-fluid g-0">
            <div class="row g-0 mb-4 justify-content-center">
                <div class=" col-24  mb-3 ">
                    <div class="has-shadow panel panel--primary h-100 d-flex justify-content-between align-items-between flex-column p-3">
                        <div class="row flex-row justify-content-between">
                            <div class="col-12">
                                <span class="summary-title">
                                    Your booking
                                </span>

                            </div>
                            <div class="col-12 d-flex justify-content-end">

                                <button type="button" class="btn-summary"
                                        v-bind:class="{'btn-summary--on': showSummary}"
                                        v-on:click="showSummary = !showSummary">
                                    Show Summary
                                </button>
                            </div>
                        </div>



                        <div class="row mt-3" v-if="showSummary">
                            <div class="col-24">
                                <div class="row">

                                    <div class="mb-0"
                                         v-bind:class="col-24"
                                         v-bind:key="legSummary.leg"
                                         v-for="legSummary in roomSummaries">
                                        <div class="panel  p-3   h-100 " v-bind:class="getCssClass(legSummary.leg)">
                                            <div class="row">
                                                <div class="col-xl-4">
                                                    <span class="room">
                                                        Room {{legSummary.leg}}:
                                                    </span>
                                                </div>
                                                <div class="col-xl-20">
                                                    <div class="row">
                                                        <div class="col-5"><span class="summary-label">Guests:</span></div>
                                                        <div class="col-14"> {{legSummary.guestCountSummary}}</div>
                                                        <div class="col-5"> </div>
                                                    </div>

                                                    <div class="row" v-if="legSummary.dogs">
                                                        <div class="col-5"><span class="summary-label">Dogs:</span></div>
                                                        <div class="col-14"> {{legSummary.dogs}}</div>
                                                        <div class="col-5">
                                                            <span class="room" v-if="getDogsAmount(legSummary) > 0">
                                                                &pound;{{getDogsAmount(legSummary)}}
                                                            </span>
                                                        </div>
                                                    </div>





                                                    <div class="row">
                                                        <div class="col-5"><span class="summary-label">Room:</span></div>
                                                        <div class="col-14">{{legSummary.room || '-'}}</div>
                                                        <div class="col-5"> </div>
                                                    </div>

                                                    <div class="row" v-if="legSummary.amount">
                                                        <div class="col-5"><span class="summary-label">Rate:</span></div>
                                                        <div class="col-14">{{legSummary.rate || '-'}}</div>
                                                        <div class="col-5">
                                                            <span class="room">
                                                                &pound;{{legSummary.amount}}
                                                            </span>
                                                        </div>
                                                    </div>



                                                    <div class="row" v-if="legSummary.addons.length">
                                                        <div class="col-5"><span class="summary-label">Add Ons:</span></div>
                                                        <div class="col-14">
                                                            <div v-for="(addon) in legSummary.addons">

                                                                {{addon || '-'}}
                                                            </div>
                                                        </div>
                                                        <div class="col-5">
                                                            <span class="room" v-if="legSummary.addonsAmount > 0">
                                                                &pound;{{legSummary.addonsAmount}}
                                                            </span>

                                                        </div>
                                                    </div>



                                                    <div class="row" v-if="legSummary.children">
                                                        <div class="col-5"><span class="summary-label">Children:</span></div>
                                                        <div class="col-14"> {{legSummary.children}}</div>
                                                        <div class="col-5">
                                                            <span class="room" v-if="getChildrenAmount(legSummary) != null">
                                                                &pound;{{priceFormatted(getChildrenAmount(legSummary))}}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div class="row" v-if="legSummary.infants">
                                                        <div class="col-5"><span class="summary-label">Infants:</span></div>
                                                        <div class="col-14"> {{legSummary.infants}}</div>
                                                        <div class="col-5">
                                                            <span class="room" v-if="getInfantsAmount(legSummary) != null">
                                                                &pound;{{priceFormatted(getInfantsAmount(legSummary))}}
                                                            </span>
                                                        </div>
                                                    </div>


                                                    <div class="row" v-if="legSummary.totalAmount && legSummary.totalAmount != legSummary.amount">
                                                        <div class="col-21"><span class="summary-label">Total:</span></div>

                                                        <div class="col-5">
                                                            <span class="room">
                                                                &pound;{{legSummary.totalAmount}}
                                                            </span>
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>



</template>

<script>

    import { store } from '../store/index';


    export default {
        name: 'RoomSummary',
        props: {
            highlight: Boolean
        },
        data() {
            return {
                showSummary: false
            }
        },
        computed: {
            leg() {
                return this.$route.params.leg;
            },
            dates() {
                var search = store.getters.search;
                var arrivalDate = moment(search.arrivalDate);
                var departureDate = moment(search.arrivalDate).add(+search.numberOfNights, 'd');

                if ((arrivalDate.year() == departureDate.year()) && (arrivalDate.month() == departureDate.month())) {
                    return arrivalDate.format('ddd Do') + '-' + departureDate.format('ddd Do MMM YY');
                }
                if (arrivalDate.year() == departureDate.year()) {
                    return arrivalDate.format('ddd Do MMM') + '-' + departureDate.format('ddd Do MMM YY');
                }
                return arrivalDate.format('ddd Do MMM YY') + '-' + departureDate.format('ddd Do MMM YY');

            },

            roomSummaries() {


                var search = store.getters.search;
                var guestOccupancies = search.guestOccupancies;
                var booking = store.getters.booking;

                var result = [];



                for (let goi in guestOccupancies) {

                    let guestOccpancy = guestOccupancies[goi];
                    let leg = +goi + 1;
                    let currentSelection = null;
                    let children = 0;
                    let infants = 0;
                    if (booking) {
                        currentSelection = booking.legs.find(item => item.leg == leg);
                    }

                    let guestCountSummary = '';
                    if (guestOccpancy.adults == 1) {
                        guestCountSummary += "1 adult"
                    } else {
                        guestCountSummary += guestOccpancy.adults + " adults"
                    }

                    if (guestOccpancy.childCount > 0) {
                 
                       children = guestOccpancy.children.filter(item => +item.age > 3).length;
                       infants = guestOccpancy.children.filter(item => +item.age <= 3).length;

                        if (children > 0) {
                            if (children == 1) {
                                if (infants == 0) {
                                    guestCountSummary += " & ";
                                }
                                else {
                                    guestCountSummary += ", ";
                                }

                                guestCountSummary += " 1 child"
                            } else {
                                if (infants == 0) {
                                    guestCountSummary += " & ";
                                } else {
                                    guestCountSummary += ", ";
                                }

                                guestCountSummary += children + " children"
                            }
                        }
                        if (infants > 0) {

                            if (infants == 1) {
                                guestCountSummary += " & 1 infant"
                            } else {
                                guestCountSummary += " & " + infants + " infants"
                            }
                        }
                    }

                    let addons = [];
                    if (currentSelection != null && currentSelection.packages != null) {
                        for (let pi = 0; pi < currentSelection.packages.length; pi++) {
                            let p = currentSelection.packages[pi];
                            let description = '';
                            
                            if (p.item.availability.PriceCalculationMode == 0) {
                                description = p.quantity + ' x ';
                            }
                            description += p.item.content.DisplayName;
                            addons.push(description);
                        }
                    }



                    let legSummary = {
                        leg: leg,
                        guestCountSummary: guestCountSummary,
                        children: children,
                        infants: infants,
                        dogs: guestOccpancy.dogs,
                        room: currentSelection != null ? currentSelection.room.DisplayName : '',
                        rate: currentSelection != null && currentSelection.rate != undefined ? currentSelection.rate.rateGroupRate.DisplayName : '',
                        amount: currentSelection != null ? this.priceFormatted(this.getAmount(currentSelection)): '',
                        totalAmount: currentSelection != null ? this.priceFormatted(this.getTotalAmount(currentSelection)) : '',
                        addons: addons,
                        addonsAmount: currentSelection != null ? this.priceFormatted(this.getAddonsAmount(currentSelection)) : '',
                        data: currentSelection

                    }


                    result.push(legSummary);
                }


                return result;
            }
        },
        methods: {
            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },

            getCssClass(roomLeg) {
                if (this.highlight) {
                    if (roomLeg == this.leg) {

                        return 'panel--primary has-chevron panel--highlight';

                    }
                }
                return '';
            },
            getDogsAmount(leg) {
                let result = 0;
                if (leg != undefined && leg.data != null) {
                    let dogs = leg.data.includedPackages.filter(i => i.Code == 'DOG');
                    for (let pi = 0; pi < dogs.length; pi++) {
                        let p = dogs[pi];
                        let amount = p.Total;
                        result += amount;
                    }
                }
                return result;
            },
            getChildrenAmount(leg) {
                let result = 0;
                if (leg != undefined && leg.data != null) {
                    let children = leg.data.includedPackages.filter(i => i.Code == 'CHILD');
                    for (let pi = 0; pi < children.length; pi++) {
                        let p = children[pi];
                        let amount = p.Total;
                        result += amount;
                    }
                    return result;
                }

                return null;
            },

            getInfantsAmount(leg) {
                let result = 0;
                if (leg != undefined && leg.data != null) {
                    let babies = leg.data.includedPackages.filter(i => i.Code == 'BABY');
                    for (let pi = 0; pi < babies.length; pi++) {
                        let p = babies[pi];
                        let amount = p.Total;
                        result += amount;
                    }
                    return result;
                }

                return null;
            },
            getAddonsAmount(leg) {
                let result = 0;

                if (leg.packages != undefined && leg.packages.length) {
                    for (let pi = 0; pi < leg.packages.length; pi++) {
                        let p = leg.packages[pi];
                        let amount = this.getPackagePrice(leg, p);
                        result += amount;
                    }
                }
                return result;
            },
            getTotalAmount(leg) {
                let result = 0;


                if (leg != undefined && leg.rate != null) {

                    result = leg.rate.availableRate.Amount;

                    if (leg.includedPackages != undefined && leg.includedPackages != null) {
                        for (let pi = 0; pi < leg.includedPackages.length; pi++) {
                            let p = leg.includedPackages[pi];
                            let amount = p.Total;
                            result += amount;
                        }
                    }
                }


                if (leg.packages != undefined && leg.packages.length) {
                    for (let pi = 0; pi < leg.packages.length; pi++) {
                        let p = leg.packages[pi];
                        let amount = this.getPackagePrice(leg, p);
                        result += amount;
                    }
                }



                return result;
            },


            getAmount(leg) {
                let result = 0;

                if (leg != undefined && leg.rate != null) {

                    result = leg.rate.availableRate.Amount;

                    //    if (leg.includedPackages != undefined && leg.includedPackages != null) {
                    //        for (let pi = 0; pi < leg.includedPackages.length; pi++) {
                    //            let p = leg.includedPackages[pi];
                    //            let amount = p.Total;
                    //            result += amount;
                    //        }
                    //    }
                    //}


                    //if (leg.packages != undefined && leg.packages.length) {
                    //    for (let pi = 0; pi < leg.packages.length; pi++) {
                    //        let p = leg.packages[pi];
                    //        let amount = this.getPackagePrice(leg, p);
                    //        result += amount;
                    //    }
                    //}
                }
                return result;
            },
            getPackagePrice(leg, p) {
           
                if (p.item.availability.AmountOverride != undefined) {
                    return p.quantity * p.item.availability.AmountOverride;
                }

                let amount = p.item.availability.Amount;
                let postingMode = p.item.availability.PriceCalculationMode;
                let result = 0;

                switch (postingMode) {
                    case 0:
                        result = amount * p.quantity;
                        break;
                    case 1:

                        result = amount * leg.guestQuota.Adults;
                        break;
                    case 2:
                        result = amount * (leg.guestQuota.Children + leg.guestQuota.Infants);
                        break;
                    case 3:
                        result = amount * (leg.guestQuota.Adults + leg.guestQuota.Children + leg.guestQuota.Infants);
                        break;
                    case 4:
                        result = amount * p.quantity;
                        break;
                }
                return result;

            }
        }
    }
</script>

<style>

    .booking-summary {
        font-size: 14px;
        font-family: 'Montserrat';
    }

        .booking-summary .summary-title {
            font-size: 24px;
            font-family: 'Playfair Display';
        }

        .booking-summary .room {
            font-weight: bold;
            text-transform: uppercase;
        }

        .booking-summary .summary-label {
            font-weight: bold;
        }


    .booking-summary-m .panel {
        background: white;
        border: solid 1px #f1f1f1;
    }

    .btn-summary {
        border: none;
        background: none;
        background-image: url(/Assets/img/booking/summary-down.svg);
        background-size: 14px 7px;
        background-repeat: no-repeat;
        background-position: calc(100% - 10px) center;
        padding-right: 30px;
        text-align: left;
    }

    .btn-summary--on {
        background-image: url(/Assets/img/booking/summary-up.svg);
    }
</style>